<template>
    <div>
        <ui-form v-if="!messageCharged" :id="id" @input="charged" @load="setLoad"/>
        <ui-success-alert v-if="messageCharged" @input="charged"/>
        <div v-if="load" class="loader">
            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
        </div>
    </div>
</template>

<script>
import uiForm from './form'
import uiSuccessAlert from './success-alert'
import { uiLoadIndicator } from '@/components/ui'

export default {
    name: 'ui-form-public',
    components: {
        uiForm,
        uiSuccessAlert,
        uiLoadIndicator,
    },
    
    props: {
        id: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            messageCharged: false,
            load: true
        }
    },
    methods: {
        charged(val) {
            this.messageCharged = val
            this.load = !val
        },
        setLoad(val) {
            this.load = val
        }
    }
}
</script>

<style lang="stylus" scoped>
    .loader
        width 100%
        height: 100%
        background: #fff
        display: flex
        align-items: center
        justify-content: center
        z-index 3000
        top 0
        position: fixed
</style>